var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgTopIcon = function SvgTopIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 13
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "TopIcon_svg__linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff177e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6a38"
  })), /*#__PURE__*/React.createElement("style", null, ".TopIcon_svg__cls-3{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TopIcon_svg__Group_4704",
    "data-name": "Group 4704",
    transform: "translate(17 -480.904)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "TopIcon_svg__Rectangle_1066",
    "data-name": "Rectangle 1066",
    width: 30,
    height: 13,
    rx: 3,
    transform: "translate(-17 480.904)",
    opacity: 0.8,
    fill: "url(#TopIcon_svg__linear-gradient)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TopIcon_svg__TOP",
    transform: "translate(-14 489.904)",
    fontSize: 7,
    fontFamily: "Roboto-Bold,Roboto",
    fontWeight: 700,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "TOP")), /*#__PURE__*/React.createElement("g", {
    id: "TopIcon_svg__gift",
    transform: "translate(1.242 483.418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TopIcon_svg__Group_102",
    "data-name": "Group 102",
    transform: "translate(.532 4.247)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TopIcon_svg__Group_101",
    "data-name": "Group 101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TopIcon_svg__Path_64",
    "data-name": "Path 64",
    className: "TopIcon_svg__cls-3",
    d: "M32 271.692v3.193a.533.533 0 00.532.532h2.661v-3.725z",
    transform: "translate(-32 -271.692)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "TopIcon_svg__Group_104",
    "data-name": "Group 104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TopIcon_svg__Group_103",
    "data-name": "Group 103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TopIcon_svg__Path_65",
    "data-name": "Path 65",
    className: "TopIcon_svg__cls-3",
    d: "M7.983 18.426H6.3a2.068 2.068 0 00.3-.238 1.112 1.112 0 000-1.566 1.125 1.125 0 00-1.561 0 2.926 2.926 0 00-.758 1.8h-.043a2.932 2.932 0 00-.758-1.8 1.126 1.126 0 00-1.561 0 1.114 1.114 0 000 1.566 2.106 2.106 0 00.3.238H.532a.533.533 0 00-.532.533v.8a.266.266 0 00.266.266h3.459v-1.066H4.79v1.064h3.459a.266.266 0 00.266-.266v-.8a.533.533 0 00-.532-.531zm-4.289-.018a.175.175 0 01-.1.018 2.617 2.617 0 01-1.3-.613A.58.58 0 012.3 17a.567.567 0 01.8 0c.361.359.718 1.281.594 1.409zm1.225.018c-.076 0-.1-.017-.1-.018-.124-.128.233-1.05.591-1.411a.573.573 0 11.806.815 2.616 2.616 0 01-1.297.614z",
    transform: "translate(0 -16.308)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "TopIcon_svg__Group_106",
    "data-name": "Group 106",
    transform: "translate(4.79 4.247)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TopIcon_svg__Group_105",
    "data-name": "Group 105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "TopIcon_svg__Path_66",
    "data-name": "Path 66",
    className: "TopIcon_svg__cls-3",
    d: "M288 271.692v3.725h2.661a.532.532 0 00.532-.532v-3.193z",
    transform: "translate(-288 -271.692)"
  })))))));
};
export default SvgTopIcon;